import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MaterialModule} from "../../../material.module";
import {SettingEditComponent} from "./setting-edit/setting-edit.component";
import {ReactiveFormsModule} from "@angular/forms";
import {FlexModule} from "@angular/flex-layout";

@NgModule({
  declarations: [SettingEditComponent],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FlexModule
  ],
  exports: []
})
export class SettingsModule { }
